import React, { useState } from 'react';
import {
  Paper,
  Typography,
  TextField,
  Button,
  Grid,
  MenuItem,
  Box,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const Calculator = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    age: '',
    gender: '',
    coverageAmount: '',
    insuranceType: '',
    smokingStatus: '',
  });
  const [premium, setPremium] = useState<number | null>(null);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };

  const calculatePremium = () => {
    // Add your premium calculation logic here
    setPremium(100); // Example value
  };

  return (
    <Paper elevation={3} sx={{ p: 4 }}>
      <Typography variant="h4" gutterBottom>
        {t('calculator.title')}
      </Typography>
      
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label={t('calculator.age')}
            name="age"
            type="number"
            value={formData.age}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            select
            label={t('calculator.gender')}
            name="gender"
            value={formData.gender}
            onChange={handleChange}
          >
            <MenuItem value="male">{t('calculator.male')}</MenuItem>
            <MenuItem value="female">{t('calculator.female')}</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label={t('calculator.coverageAmount')}
            name="coverageAmount"
            type="number"
            value={formData.coverageAmount}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            select
            label={t('calculator.insuranceType')}
            name="insuranceType"
            value={formData.insuranceType}
            onChange={handleChange}
          >
            <MenuItem value="term">{t('calculator.term')}</MenuItem>
            <MenuItem value="whole">{t('calculator.whole')}</MenuItem>
            <MenuItem value="universal">{t('calculator.universal')}</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            select
            label={t('calculator.smokingStatus')}
            name="smokingStatus"
            value={formData.smokingStatus}
            onChange={handleChange}
          >
            <MenuItem value="no">{t('calculator.no')}</MenuItem>
            <MenuItem value="yes">{t('calculator.yes')}</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={12}>
          <Button
            variant="contained"
            color="primary"
            onClick={calculatePremium}
            fullWidth
          >
            {t('calculator.calculate')}
          </Button>
        </Grid>
      </Grid>

      {premium !== null && (
        <Box mt={4}>
          <Typography variant="h5" align="center">
            {t('calculator.estimatedPremium')}: ${premium}
          </Typography>
          <Typography variant="caption" display="block" align="center" color="text.secondary">
            {t('calculator.disclaimer')}
          </Typography>
        </Box>
      )}
    </Paper>
  );
};

export default Calculator; 